"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personViewModel = personViewModel;
const data_fetching_1 = require("../data-fetching/index.js");
function getPersonDisplayName(person) {
    return person.name || `${person.givenName || ""} ${person.familyName || ""}`.trim();
}
function getPersonAvatar(person, baseUrl) {
    const avatar = (0, data_fetching_1.findImageByType)(person.images, "avatar");
    if (avatar)
        return { type: "avatar", urls: (0, data_fetching_1.resolveImageUrls)(avatar.urls, baseUrl) };
    const portrait = (0, data_fetching_1.findImageByType)(person.images, "portrait");
    if (portrait)
        return { type: "portrait", urls: (0, data_fetching_1.resolveImageUrls)(portrait.urls, baseUrl) };
    return undefined;
}
function personViewModel(person, baseUrl) {
    return {
        ...person,
        displayName: getPersonDisplayName(person),
        avatar: getPersonAvatar(person, baseUrl),
    };
}
